import style from './subheader.scss'
import { Component } from 'preact';

class SubHeader extends Component {
    renderHeading(){
        const {heading} = this.props || {};
        if(!!heading){
            return (<h1 className={'fancy-heading'}><span>{heading}</span></h1>)
        }
    }
    renderSubHeading(){
        const {subheading} = this.props || {};
        if(!!subheading){
            return (<h3 className={'subheading'}>{subheading}</h3>)
        }
    }
    render(){
        return (
            <div className={'subheader-wrapper'}>
                {this.renderHeading()}
                {this.renderSubHeading()}
            </div>
        )
    }
}

export default SubHeader;



// WEBPACK FOOTER //
// ./components/layout/subheader/index.js